import { useMediaQuery } from "@material-ui/core";
import { screenSizes } from "../theme/newLyfeTheme";

export const useResponsive = () => {
	const isSmallScreen = useMediaQuery(`(max-width:${screenSizes.base}px)`);
	const isMediumScreen = useMediaQuery(`(min-width:${screenSizes.medium}px) and (max-width:${screenSizes.large - 1}px)`);
	const isLargeScreen = useMediaQuery(`(min-width:${screenSizes.large}px) and (max-width:${screenSizes.extraLarge - 1}px)`);
	const isExtraLargeScreen = useMediaQuery(`(min-width:${screenSizes.extraLarge + 1}px)`);

	return {
		isSmallScreen,
		isMediumScreen,
		isLargeScreen,
		isExtraLargeScreen,
	};
};
